document.addEventListener('DOMContentLoaded',function(){
    document.querySelector('[data-selling-plan-container]')?.remove()

    window.select_subcribe = () =>{
        document.querySelectorAll('input[name="subscription_option"]').forEach(input => {
            input.addEventListener('change',function(){
                if(this.value == "one-time"){
                    document.getElementById('plans').setAttribute('disabled','disabled');
                    document.querySelector('.form.product-purchase-form [name="selling_plan"]').value = '';
                }else{
                    document.getElementById('plans').removeAttribute('disabled');
                    document.querySelector('.form.product-purchase-form [name="selling_plan"]').value = document.getElementById('plans').value
                    document.getElementById('plans').addEventListener('change',(e) =>{
                        document.querySelector('.form.product-purchase-form [name="selling_plan"]').value = e.target.value;
                    })
                }
            })
        })
    }
    window.select_subcribe();
    const products_upsell = () =>{
        document.querySelectorAll('.upsell-product-value').forEach(select => {
            select.addEventListener('change',() =>{
                let variant_id = select.value;
                let option_ele = document.querySelector('.upsell-product-value option[value="'+variant_id+'"]');
                let price = option_ele.getAttribute('data-price');
                select.closest('.upsell-product').querySelector('.upsell-product-title__price').innerHTML = theme.Shopify.formatMoney(price,theme.money_format)
            })
        })
        $('.upsell-products').slick({
            dots: true
        });
    }
    products_upsell();
    const upsell_product_atc = () => {
        if(document.querySelectorAll('.upsell-product-atc-btn').length > 0){
            document.querySelectorAll('.upsell-product-atc-btn').forEach(x => {
                x.addEventListener('click',function(){
                    let variant_id = x.closest('.upsell-product-action').querySelector('.upsell-product-value').value;
                    $.ajax({
                        type: "POST",
                        url: "/cart/add.js",
                        data: {
                            id: variant_id,
                            quantity: 1
                        },
                        dataType: "json",
                        success: function (cart) {
                            console.log("added gift cart");
                            document.querySelector('.js-cart-opener').click();
                        },
                        error: function (e) {
                            console.error(e);
                        },
                    }).done(function () {
                        console.log("done");
                    });
                })
            })
        }
    }
    upsell_product_atc();
    const open_description_tab = () => {
        document.querySelectorAll('.collapsible-tab-item-toggle').forEach(x => {
            x.addEventListener('click',() =>{
                if(x.parentElement.classList.contains('active')){
                    x.parentElement.classList.remove('active');
                }else{
                    x.parentElement.classList.add('active');
                }
            })
        })
    }
    open_description_tab();
    const donate = () => {
        const donation = (e) =>{
            if(e.target.checked){
                $.ajax({
                    type: "POST",
                    url: "/cart/add.js",
                    data: {
                        id: 34859821858966,
                        quantity: 1
                    },
                    dataType: "json",
                    success: function (cart) {
                        if(window.location.pathname == "/cart"){
                            window.location.reload();
                        }else{
                            document.dispatchEvent(new Event('donate'))
                        }
                    },
                    error: function (e) {
                        console.error(e);
                    },
                }).done(function () {
                    console.log("done");
                });
            }
        }
        if(document.getElementById('rspca_donation') != null){
            document.getElementById('rspca_donation').addEventListener('click',(e) => donation(e))
        }
        if(window.location.pathname == "/cart"){
            document.getElementById('rspca_donation_cart_page').addEventListener('click',(e) =>  donation(e))
        }
    }
    donate()
    $('.collection-tabs li').click(function () {
        $('.collection-listing').removeClass('active')
        $('.collection-tabs li').removeClass('active')
        const index = $(this).attr('data-index')
        $(this).addClass('active')
        $(`.collection-listing[data-index="${index}"]`).addClass('active')
    })
    if($('.announcement-bar__middle')) {
        $('.announcement-bar__middle').slick({
            autoplay: true,
            autoplaySpeed: 2000,
            dots:false,
            arrows:false
        })
    }


    function initSlider() {
      const slidersSwipper = document.querySelectorAll('.swiper')
      window.slideTime = 0
      const hiddenScroll = (el) => {
        const interval = setInterval(() => {
          if(window.slideTime <= 0) {
            el.classList.remove('active')
            clearInterval(interval)
          }
          window.slideTime--
        },500)
      }
      slidersSwipper.forEach((slide) => {
            const swiper = new Swiper(slide, {
                // Optional parameters
                loop: false,
                slidesPerView: 1.2,
                spaceBetween: 10,
                // If we need pagination
                pagination: {
                    el: '.swiper-pagination',
                },

                // Navigation arrows
                navigation: {
                    nextEl: '.swiper-button-next',
                    prevEl: '.swiper-button-prev',
                },

                // And if we need scrollbar
                scrollbar: {
                    el: '.swiper-scrollbar',
                },
                breakpoints: {
                    640: {
                        slidesPerView: 3
                    },
                    1024: {
                        slidesPerView: 4
                    }
                },
                on: {
                  transitionEnd: function () {
                    hiddenScroll(slide.querySelector('.swiper-scrollbar'))
                  },
                  slideChange: function () {
                    window.slideTime = 2
                    slide.querySelector('.swiper-scrollbar')?.classList.add('active')
                  },
                  touchMove:function() {
                    window.slideTime = 2
                    slide.querySelector('.swiper-scrollbar')?.classList.add('active')
                  }
                }
            });
        })
    }

    initSlider()

    document.addEventListener("initSlider",initSlider,false);

})